import { Phone, Mail } from "lucide-react";

const ExecutiveCommittee = () => {
  const officers = [
    { role: "President", name: "Mr. Pradeep Kumar Kotari", phone: "+91 8309427311" },
    { role: "Vice President", name: "Mrs. Rajeshwari Menon", phone: "+91 9840074282" },
    { role: "Secretary", name: "Mrs. Rachita", phone: "+91 9962644703" },
    { role: "Joint Secretary", name: "Mr. Udit Garg", phone: "+91 7358058472" },
    { role: "Treasurer", name: "Mr. Pandarasivan Swaminathan", phone: "+91 9443697060" },
  ];

  const members = [
    { portfolio: "EC Sports", name: "Mr. V. Visweswaran" },
    { portfolio: "EC Clubhouse", name: "Mrs. Viji Venkat" },
    { portfolio: "EC Cultural", name: "Mrs. Chithrakala Rajasekaran" },
    { portfolio: "EC Housekeeping", name: "Mrs. Gayathri" },
    { portfolio: "EC Member", name: "Mr. Radhakrishnan Venkataraman" },
    { portfolio: "EC Member", name: "Col R. Arun" },
    { portfolio: "EC Member", name: "Mrs. Nuzhat Fatimah" },
    { portfolio: "EC Member", name: "Mr. Krishnadas" },
    { portfolio: "EC Member", name: "Mr. Anand Sundaramurthy" },
    { portfolio: "EC Member", name: "Mr. K. Ravidranath" },
    { portfolio: "EC Fire & Emergency Response", name: "Mr. Sundararajan" },
    { portfolio: "EV Committee", name:"Mr. Muthu" },
  ];

  return (
    <section id="committee" className="py-20 sm:py-28 bg-white">
      <div className="section-container">
        <h2 className="section-title">Executive Committee (2025-26)</h2>
        <p className="section-subtitle">
          Elected representatives governing PSAOA under the Tamil Nadu Societies Registration Act, 1975
        </p>

        {/* Term & Authority Info */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mb-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">Term Duration</p>
              <p className="text-lg font-bold text-foreground">November 2025 – October 2026</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">Authority</p>
              <p className="text-lg font-bold text-foreground">General Body of Members</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">Official Contact</p>
              <p className="text-lg font-bold text-blue-600">office.psaoa@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Officers Section */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-foreground mb-8">
            Core Officers
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {officers.map((officer, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-lg p-6 hover:shadow-lg hover:border-blue-300 transition-all duration-300"
              >
                <div className="mb-3">
                  <p className="committee-role">{officer.role}</p>
                  <p className="committee-name">{officer.name}</p>
                </div>
                <div className="flex items-center gap-2 text-xs text-muted-foreground mt-4 pt-4 border-t border-slate-200">
                  <Phone className="w-3.5 h-3.5" />
                  <a href={`tel:${officer.phone.replace(/\s+/g, '')}`} className="hover:text-blue-600 transition-colors">
                    {officer.phone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Protocol */}
        <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg mb-12">
          <p className="text-blue-900 text-sm">
            <span className="font-bold">Contact Protocol:</span> All official correspondence should be directed to the Association office email at <span className="font-semibold">office.psaoa@gmail.com</span>. For inquiries regarding specific portfolios, please contact the office and we will direct your request to the appropriate committee member.
          </p>
        </div>

        {/* Members Section */}
        <div>
          <h3 className="text-2xl font-bold text-foreground mb-8">
            Committee Members ({members.length})
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {members.map((member, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-lg p-6 hover:shadow-lg hover:border-blue-300 transition-all duration-300"
              >
                <p className="committee-role">{member.portfolio}</p>
                <p className="committee-name">{member.name}</p>
                <p className="text-xs text-muted-foreground mt-4 pt-4 border-t border-slate-200">
                  Contact via office email
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Summary Stats */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-3xl font-bold text-blue-600">17</p>
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-2">Total EC Members</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-indigo-600">5</p>
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-2">Core Officers</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-purple-600">11</p>
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-2">Committee Members</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExecutiveCommittee;
